export const ja = {
  heroData: {
    title: "お知らせ",
    subtitle: "AIRDOAの最新情報をお届けします。",
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20with%20natural%20light%2C%20open%20notebook%20and%20laptop%20on%20clean%20desk%2C%20warm%20ambient%20lighting%2C%20editorial%20news%20update%20concept%2C%20no%20text&width=1920&height=600&seq=newshero01&orientation=landscape",
  },
  categories: [
    { id: "all", label: "すべて" },
    { id: "news", label: "お知らせ" },
    { id: "column", label: "コラム" },
    { id: "media", label: "メディア" },
    { id: "campaign", label: "キャンペーン" },
  ],
  newsItems: [
    { type: "news", title: "横浜ヘリクルージング 2025年ゴールデンウィーク特別プランのご案内", category: "お知らせ", date: "2025.04.01", slug: "yokohama-golden-week-2025", excerpt: "2025年ゴールデンウィーク期間中の特別プランについてご案内いたします。" },
    { type: "news", title: "ギフトチケット 早期購入特典について", category: "お知らせ", date: "2025.03.20", slug: "gift-ticket-early-benefit", excerpt: "ギフトチケットを4月末日までにご購入いただくと、特典がつく期間限定キャンペーンのご案内です。" },
    { type: "column", title: "コラム更新のお知らせ", category: "コラム", date: "2025.03.15", slug: "column-update", excerpt: "「横浜ヘリデートを成功させる5つのポイント」をはじめ、新着コラムを掲載しました。" },
    { type: "news", title: "AIRDOAオープンのお知らせ", category: "お知らせ", date: "2025.01.01", slug: "airdoa-open", excerpt: "横浜ヘリクルージング予約メディア「AIRDOA」がオープンしました。今後の展開にご期待ください。" },
  ],
};

export const en = {
  heroData: {
    title: "News",
    subtitle: "The latest updates and announcements from AIRDOA.",
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20with%20natural%20light%2C%20open%20notebook%20and%20laptop%20on%20clean%20desk%2C%20warm%20ambient%20lighting%2C%20editorial%20news%20update%20concept%2C%20no%20text&width=1920&height=600&seq=newshero01&orientation=landscape",
  },
  categories: [
    { id: "all", label: "All" },
    { id: "news", label: "News" },
    { id: "column", label: "Column" },
    { id: "media", label: "Media" },
    { id: "campaign", label: "Campaign" },
  ],
  newsItems: [
    { type: "news", title: "Yokohama Helicopter Cruise — Special Golden Week 2025 Plans", category: "News", date: "2025.04.01", slug: "yokohama-golden-week-2025", excerpt: "Special plans available during Golden Week 2025. Find out everything you need to know." },
    { type: "news", title: "Gift Ticket Early Purchase Bonus", category: "News", date: "2025.03.20", slug: "gift-ticket-early-benefit", excerpt: "Purchase a gift ticket by the end of April and receive an exclusive bonus. Limited-time campaign." },
    { type: "column", title: "New Articles Published", category: "Column", date: "2025.03.15", slug: "column-update", excerpt: "New articles are now available, including '5 Tips for a Perfect Yokohama Helicopter Date.'" },
    { type: "news", title: "AIRDOA Is Now Open", category: "News", date: "2025.01.01", slug: "airdoa-open", excerpt: "AIRDOA, the Yokohama helicopter cruise booking media, is officially open. Stay tuned for more." },
  ],
};
